<template>
  <div class="ac-snooze ac-card-content">
    <div class="ac-header-note">
      <button
        type="button"
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
      <div v-if="isEdit" class="ac-header">
        Edit Note
      </div>
      <div v-else class="ac-header">
        Add Note
      </div>
    </div>
    <div class="ac-body-container">
      <div v-if="isEdit" class="sac__font-14 semi-bold margin-top-16">
        {{ selectedNote.userName }} - {{ formatNoteDate(selectedNote.noteDate) }} at
        {{ formatTime(selectedNote.noteDate) }}
      </div>
      <div class="input-textarea">
        <SACInput
          :value="newNote"
          type="textarea"
          placeholder="Add note here.."
          :error="errObj.newNoteErr"
          :change="onChange"
        />
        <div
          :class="[
            'ac-count-container',
            newNote.length > 500 ? 'error-text' : null,
          ]"
        >
          {{ newNote.length }}/500
        </div>
      </div>
    </div>
    <div class="ac-footer-container">
      <div />
      <button
        :disabled="loading"
        type="button"
        class="sac__button bg-primary grid-column ai-c gap-10"
        @click="handleAction"
      >
        <img v-if="loading" src="@shared/assets/img/general/loading-mini-white.svg" alt="Loading">
        <fragment v-else>
          <span class="sac__font-16 semi-bold">Save</span>
          <img
            src="@shared/assets/img/service/white-check.svg"
            alt="action"
            class="img-size-24"
          >
        </fragment>
      </button>
    </div>
  </div>
</template>

<script>
import serviceMixin from '@shared/mixins/serviceMixin';
import SACInput from '@shared/components/sac/SACInput.vue';
import formatterMixin from '@shared/mixins/formatterMixin';
import moment from 'moment';

export default {
  name: 'AddNote',
  components: {
    SACInput,
  },
  mixins: [serviceMixin, formatterMixin],
  props: {
    isEdit: Boolean,
  },
  data() {
    return {
      logs: [],
      loading: false,
      errObj: {},
    };
  },
  computed: {
    newNote: {
      get() {
        if (!this.selectedNote.note) {
          return '';
        }
        return this.selectedNote && this.selectedNote.note;
      },
    },
  },
  methods: {
    onChange(_, value) {
      this.$store.dispatch('changeServiceValue', {
        field: 'selectedNote',
        value: {
          ...this.selectedNote,
          note: value,
        },
      });
    },
    async handleAction() {
      const errObj = {};
      if (this.newNote.length > 500) {
        errObj.newNoteErr = 'Notes are limited to 500 characters';
      }
      this.errObj = errObj;
      if (Object.keys(errObj).length === 0) {
        this.loading = true;
        if (this.isEdit) {
          await this.saveExistingNote();
        } else {
          await this.saveNewNote();
        }
      }
      this.toggleActionModal(false);
      this.loading = false;
    },
    async saveExistingNote() {
      await this.$store.dispatch('updateNote', this.selectedNote);
    },
    async saveNewNote() {
      const noteRequest = {
        actionStatusDate: moment().toISOString(),
        actionNote: this.newNote,
        actionStatus: 'Note',
      };
      await this.$store.dispatch('createServiceNote', noteRequest);
    },
  },
};
</script>

<style lang="scss" scoped>
.ac-note-header {
  border-bottom: 1px solid $N10;
  font-weight: 600;
}
.ac-sub-header {
  font-size: 1.0rem;
  font-weight: 500;
  margin-bottom: 5px;
}
.input-textarea {
  margin-top: 1rem;
  position: relative;
  background-color: $N5;
}
.ac-count-container {
  bottom: 20px;
  right: 20px;
  position: absolute;
  margin-top: 8px;
  color: $N50;
  font-weight: 500;
  font-size: 12px;
  &.error-text {
    color: $TOMATO100;
  }
}

</style>
